import { toPng } from 'html-to-image';

function safeFileName(name) {
  return (name || 'share')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export async function renderNodeToPngBlob(node, { width, height } = {}) {
  if (!node) throw new Error('Missing node to render');

  const dataUrl = await toPng(node, {
    cacheBust: true,
    pixelRatio: 2,
    backgroundColor: '#0b1220',
    width,
    height,
    // Avoid reading cross-origin stylesheets (e.g. Google Fonts on the page) — would throw SecurityError on cssRules.
    skipFonts: true,
  });

  const res = await fetch(dataUrl);
  return await res.blob();
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function canWebShareFiles() {
  try {
    return (
      typeof navigator !== 'undefined' &&
      typeof navigator.share === 'function' &&
      typeof navigator.canShare === 'function' &&
      navigator.canShare({
        files: [new File([new Blob(['x'])], 'x.png', { type: 'image/png' })],
      })
    );
  } catch {
    return false;
  }
}

export async function shareOrDownloadPng({ blob, filename, title, text } = {}) {
  if (!blob) throw new Error('Missing image blob');
  const name = filename || `${safeFileName(title) || 'share'}.png`;

  if (canWebShareFiles()) {
    try {
      const file = new File([blob], name, { type: 'image/png' });
      // iOS Safari often rejects sharing files together with title/text; share image only.
      await navigator.share({ files: [file] });
      return 'shared';
    } catch (e) {
      if (e && e.name === 'AbortError') return 'aborted';
    }
  }

  downloadBlob(blob, name);
  return 'downloaded';
}

